/**
 * Execute a fetching function and caches the resulting promise. When the method is called subsequently the cache is
 * hit regardless of whether the promise has resolved or not. However, if the promise fails to resolve it's removed
 * from the cache so when another request comes _after_ the promise failed the fetch function is called again.
 *
 * @param {Map<string, Promise<*>>} cache
 * @param {string} key
 * @param {function(): Promise<*>} fetchFunction
 * @returns {Promise<*>}
 * @private
 */
export function cacheWithErrorCheck(cache, key, fetchFunction) {
  if (cache.has(key)) {
    return cache.get(key); // Returns cached promise, if present
  }

  const promise = fetchFunction(); // Promise of the fetch function result

  const errorCheckedPromise = promise.catch(error => {
    cache.delete(key);
    throw error;
  }); // Promise enhanced with cache cleaning on error

  cache.set(key, errorCheckedPromise); // Whole promise is cached

  return errorCheckedPromise;
}
